import { render } from "./TareaShow.vue?vue&type=template&id=19319158"
import script from "./TareaShow.vue?vue&type=script&lang=js"
export * from "./TareaShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__